import * as React from 'react';
import cn from 'classnames';

import Paper, { PaperProps } from '@mui/material/Paper';

import { useTheme } from '../../../theme';

const RefundPaper: React.FC<PaperProps> = props => {
	const { RefundPaper: css } = useTheme('Refund');

	return (
		<Paper elevation={0} square {...props} className={cn(css.paper, props.className)}>
			{props.children}
		</Paper>
	);
};

export default RefundPaper;
